import storage from "@storage";
import { v4 as uuid } from "uuid";

const deviceIdGenerator = () => {
  let deviceId = storage.get("deviceId");
  if (!deviceId) {
    const generatedId = uuid();
    storage.set("deviceId", generatedId);
    deviceId = generatedId;
  }

  return {
    deviceId,
    deviceName: "Web Browser"
  };
};

export default deviceIdGenerator;
